import React from 'react';
import { StyleSheet, View } from 'react-native';
import { Colors } from '../constants/Colors';

type Props = {
  currentStep: number;
  totalSteps: number;
};

export function ProgressBar({ currentStep, totalSteps }: Props) {
  const steps = Array.from({ length: totalSteps }, (_, i) => i + 1);

  return (
    <View style={styles.container}>
      {steps.map((step) => (
        <View
          key={step}
          style={[
            styles.step,
            step <= currentStep ? styles.stepFilled : styles.stepEmpty,
          ]}
        />
      ))}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    gap: 8,
    width: '100%',
  },
  step: {
    flex: 1,
    height: 4,
    borderRadius: 2,
  },
  stepFilled: {
    backgroundColor: Colors.pink0,
  },
  stepEmpty: {
    backgroundColor: Colors.pink0opacity50,
  },
});
